export default function CheckBox({ name, tick, onCheck }) {
  return (
    <div className="box-checkbox">
      <input
        className="form-check-input"
        type="checkbox"
        name={name}
        checked={tick}
        onChange={onCheck}
      />
    </div>
  );
}
